module.exports = __webpack_public_path__ + "static/media/XLV_Block.6d26b64f.jpg";